import {Stack, Typography} from '@mui/material';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import React from 'react';

const {header} = translations['pt-br'].privateFlow.bookingFlow.requestSchedule;

export const RequestScheduleHeader = () => {
	const {SEARCH_PARAMS} = useQueryParams();
	const {ufName, cityName, specialtyName} = SEARCH_PARAMS;

	const specialtyNameFormatted = formatText(specialtyName);
	const localityTextFormatted = `${formatText(cityName)}/${formatText(ufName)}`;

	return (
		<Stack>
			<Typography variant="body2" color="text.secondary">
				{header.line1} <b>{specialtyNameFormatted}</b>
				{header.line2}
				<b>{localityTextFormatted}</b>.
			</Typography>
		</Stack>
	);
};
